// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"522":"4b71167d","630":"ec214e45"}[chunkId] + ".chunk.js";
};